// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TimeTrackingPage.css */

/* Animation für Einblenden */
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.animate-fadeIn {
  animation: fadeIn 0.3s ease-in-out;
}

/* Pulsierend für aktiv laufende Zeiterfassung */
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(79, 70, 229, 0.2);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(79, 70, 229, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(79, 70, 229, 0);
  }
}

.active-time-entry {
  animation: pulse 2s infinite;
}

/* Verbesserte Hover-Effekte */
.hover-lift {
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.hover-lift:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

/* Verbesserte Focus-Stile */
.focus-ring:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.3);
}

/* Verbesserter Schatten für Karten */
.card-shadow {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease-in-out;
}

.card-shadow:hover {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Verbesserte Tabellen-Stile */
.modern-table {
  border-collapse: separate;
  border-spacing: 0;
}

.modern-table th {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 10;
}

.modern-table tr {
  transition: background-color 0.15s ease-in-out;
}

.modern-table tr:hover td {
  background-color: rgba(243, 244, 246, 0.8);
}

/* Verbessertes Scrollen */
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #c5c5c5;
  border-radius: 10px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}

/* Badge-Stile */
.badge {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.5rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 500;
}

.badge-active {
  background-color: rgba(16, 185, 129, 0.1);
  color: rgb(6, 95, 70);
}

/* Responsive Anpassungen */
@media (max-width: 640px) {
  .responsive-card {
    padding: 1rem;
    margin-bottom: 1rem;
  }
  
  .responsive-text {
    font-size: 0.875rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/pages/TimeTrackingPage.css"],"names":[],"mappings":"AAAA,yBAAyB;;AAEzB,6BAA6B;AAC7B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA,gDAAgD;AAChD;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,8BAA8B;AAC9B;EACE,mEAAmE;AACrE;;AAEA;EACE,2BAA2B;EAC3B,iFAAiF;AACnF;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,4CAA4C;AAC9C;;AAEA,qCAAqC;AACrC;EACE,uEAAuE;EACvE,uCAAuC;AACzC;;AAEA;EACE,uEAAuE;AACzE;;AAEA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,0BAA0B;AAC1B;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* TimeTrackingPage.css */\n\n/* Animation für Einblenden */\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.animate-fadeIn {\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n/* Pulsierend für aktiv laufende Zeiterfassung */\n@keyframes pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(79, 70, 229, 0.2);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(79, 70, 229, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(79, 70, 229, 0);\n  }\n}\n\n.active-time-entry {\n  animation: pulse 2s infinite;\n}\n\n/* Verbesserte Hover-Effekte */\n.hover-lift {\n  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;\n}\n\n.hover-lift:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n/* Verbesserte Focus-Stile */\n.focus-ring:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.3);\n}\n\n/* Verbesserter Schatten für Karten */\n.card-shadow {\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);\n  transition: box-shadow 0.3s ease-in-out;\n}\n\n.card-shadow:hover {\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05), 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n/* Verbesserte Tabellen-Stile */\n.modern-table {\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.modern-table th {\n  position: sticky;\n  top: 0;\n  background-color: white;\n  z-index: 10;\n}\n\n.modern-table tr {\n  transition: background-color 0.15s ease-in-out;\n}\n\n.modern-table tr:hover td {\n  background-color: rgba(243, 244, 246, 0.8);\n}\n\n/* Verbessertes Scrollen */\n.custom-scrollbar::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background: #c5c5c5;\n  border-radius: 10px;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb:hover {\n  background: #a1a1a1;\n}\n\n/* Badge-Stile */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.2rem 0.5rem;\n  border-radius: 9999px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.badge-active {\n  background-color: rgba(16, 185, 129, 0.1);\n  color: rgb(6, 95, 70);\n}\n\n/* Responsive Anpassungen */\n@media (max-width: 640px) {\n  .responsive-card {\n    padding: 1rem;\n    margin-bottom: 1rem;\n  }\n  \n  .responsive-text {\n    font-size: 0.875rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
